import React from 'react';
import ContentHeader from './ContentHeader';
import ContentDescription from './ContentDescription';

const DemonstrationBody = ({ description, ...props }) => (
  <div className="PathContent">
    <ContentHeader {...props} />
    {description && (
      <div className="PathContent-body">
        <ContentDescription description={description} />
      </div>
    )}
  </div>
);

export default DemonstrationBody;
